import type { ReactNode } from 'react';
import { Box, Card, CardContent, Typography } from '@mui/material';
import { t } from '../../i18n/sq';
import { BrandLogo } from '../../components/BrandLogo';
import { TextSizeToggle } from '../../components/TextSizeToggle';

/** Centered card layout shared by all signed-out screens. */
export function AuthShell({
  title,
  subtitle,
  children,
}: {
  title: string;
  subtitle?: string;
  children: ReactNode;
}) {
  return (
    <Box
      sx={{
        minHeight: '100dvh',
        position: 'relative',
        display: 'grid',
        placeItems: 'center',
        p: 2,
        background: (th) =>
          `radial-gradient(1200px 600px at 10% -10%, rgba(${th.vars!.palette.primary.mainChannel} / 0.14), transparent), ${th.vars!.palette.background.default}`,
      }}
    >
      <Box sx={{ position: 'absolute', top: 12, right: 12 }}>
        <TextSizeToggle />
      </Box>
      <Box sx={{ width: '100%', maxWidth: 440 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 3 }}>
          <BrandLogo tagline sx={{ height: { xs: 72, sm: 84 } }} />
          <Typography
            variant="overline"
            color="text.secondary"
            sx={{ mt: 1.5, letterSpacing: '0.08em' }}
          >
            {t.appTagline}
          </Typography>
        </Box>
        <Card sx={{ borderRadius: 3 }}>
          <CardContent sx={{ p: { xs: 3, sm: 4 } }}>
            <Typography variant="h5" component="h1" gutterBottom>
              {title}
            </Typography>
            {subtitle && (
              <Typography color="text.secondary" sx={{ mb: 3 }}>
                {subtitle}
              </Typography>
            )}
            {children}
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
}
